import { render } from "./ListMedecin.vue?vue&type=template&id=1b110605"
import script from "./ListMedecin.vue?vue&type=script&lang=js"
export * from "./ListMedecin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__